import axios, {
  AxiosRequestConfig,
  AxiosResponse,
} from 'axios';
import {
  baseApiUrl,
} from 'env';
// @INFO: !!! uncomment if you need to mock API

// import MockAdapter from 'axios-mock-adapter';
// mock samples below

export const axiosInstance = axios.create({ baseURL: baseApiUrl });
const axiosExternalInstance = axios.create();
const mockedUrls = new Set<string>([]);

type RequestFlags = {
  isMock?: boolean;
  isExternal?: boolean;
};

export function sendRequest<T>(
  config: AxiosRequestConfig,
  options?: AxiosRequestConfig,
  flags?: RequestFlags,
): Promise<T> {
  const { isMock = false, isExternal = false } = flags ?? {};
  const httpClient = isMock
    || isExternal
    || mockedUrls.has(config.url?.toLowerCase() ?? '')
    ? axiosExternalInstance
    : axiosInstance;
  const source = axios.CancelToken.source();
  const promise = httpClient({
    ...config,
    ...options,
    cancelToken: source.token,
  }).then(({ data }: AxiosResponse<T>) => data);
  // @ts-ignore
  promise.cancel = () => {
    source.cancel('Query was cancelled.');
  };
  return promise;
}

// @INFO: !!! uncomment if you need to mock API
// const mockHttpAdapter = new MockAdapter(axiosMockInstance);
// e.g
// mockHttpAdapter
//   .onPost('/api/EFax/GetFaxes')
//   .reply(200, faxList);
